import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import WhatsAppButton from 'components/ui/WhatsAppButton';
import Icon from 'components/AppIcon';


const PartnersPage = () => {
  const partners = [
  {
    name: 'ESCEN',
    fullName: 'École Supérieure de Commerce & de l\'Économie Numérique',
    role: 'Partenaire Académique & Formation',
    description: 'ESCEN est une école de commerce spécialisée dans l\'économie numérique. Notre partenariat permet d\'offrir des formations de pointe en marketing digital, e-commerce et transformation digitale, combinant excellence académique et expertise pratique.',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1116b71be-1769391961596.png",
    website: 'https://www.escen.fr',
    benefits: [
    'Programmes de formation certifiants',
    'Expertise en économie numérique',
    'Diplômes reconnus internationalement',
    'Accompagnement personnalisé']

  },
  {
    name: 'Google',
    fullName: 'Google Marketing Digital',
    role: 'Partenaire Technologique & Certification',
    description: 'Google est notre partenaire stratégique pour les certifications en marketing digital. Nous proposons des formations certifiées Google permettant à nos clients de maîtriser les outils et stratégies du marketing digital moderne.',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbd151f0-1764646558738.png",
    website: 'https://www.google.com',
    benefits: [
    'Certifications Google reconnues mondialement',
    'Accès aux outils Google Marketing',
    'Formation aux dernières technologies',
    'Expertise en analytics et publicité digitale']

  }];


  const clients = [
  {
    name: 'Port Autonome de Pointe Noire',
    country: 'Congo',
    description: 'Principal port maritime du Congo, acteur majeur du commerce international en Afrique Centrale.',
    icon: 'Anchor',
    services: 'Formation professionnelle et conseil stratégique'
  },
  {
    name: 'Port Autonome d\'Abidjan',
    country: 'Côte d\'Ivoire',
    description: 'Premier port d\'Afrique de l\'Ouest francophone, hub logistique stratégique de la région.',
    icon: 'Ship',
    services: 'Développement des compétences et transformation digitale'
  },
  {
    name: 'Port Autonome de Cotonou',
    country: 'Bénin',
    description: 'Port stratégique du Bénin, porte d\'entrée maritime pour le commerce régional.',
    icon: 'Anchor',
    services: 'Formation et accompagnement opérationnel'
  }];


  const benefits = [
  {
    icon: 'Shield',
    title: 'Sécurité & Fiabilité',
    description: 'Partenariats avec des institutions reconnues pour leur excellence et leur fiabilité.'
  },
  {
    icon: 'Zap',
    title: 'Innovation Continue',
    description: 'Accès aux dernières technologies et méthodes pédagogiques innovantes.'
  },
  {
    icon: 'Globe',
    title: 'Portée Internationale',
    description: 'Réseau de partenaires et clients à travers l\'Afrique et au-delà.'
  },
  {
    icon: 'Award',
    title: 'Excellence Certifiée',
    description: 'Certifications reconnues internationalement pour votre développement professionnel.'
  }];


  return (
    <>
      <Helmet>
        <title>Partenaires | CRF PERFECTION - Réseau d'Excellence</title>
        <meta
          name="description"
          content="Découvrez nos partenaires stratégiques ESCEN et Google, ainsi que nos clients prestigieux incluant les ports autonomes d'Afrique Centrale et de l'Ouest." />

        <meta name="keywords" content="partenaires stratégiques, ESCEN, Google, certifications, ports autonomes, CRF PERFECTION" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Header />
        <WhatsAppButton />

        {/* Section 1: Hero */}
        <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
                linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
              `,
              backgroundSize: '50px 50px'
            }} />
          </div>

          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
                <Icon name="Handshake" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Réseau d'Excellence Mondiale
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
                Nos Partenaires & Clients
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold mb-6" style={{ color: '#9B8E57' }}>
                Un écosystème de partenaires d'excellence et de clients prestigieux
              </p>
              
              <p className="text-lg text-gray-300 leading-relaxed mb-8">
                Nous collaborons avec des leaders de l'éducation et de la technologie, et accompagnons 
                des institutions majeures dans leur transformation et développement.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}>

                  Devenir Partenaire
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}>

                  Nos Services
                  <Icon name="Briefcase" size={20} className="ml-2" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Nos Partenaires */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center space-x-2 bg-gray-100 rounded-full px-4 py-2 mb-4">
                <Icon name="Handshake" size={20} style={{ color: '#96121D' }} />
                <span className="text-sm font-semibold" style={{ color: '#96121D' }}>
                  Nos Partenaires
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Nos Partenaires Sont
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Des alliances stratégiques avec des leaders de l'éducation et de la technologie
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {partners?.map((partner, index) =>
              <div
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-2xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#96121D';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>

                  {/* Partner Logo */}
                  <div className="bg-white rounded-xl p-6 mb-6 h-32 flex items-center justify-center shadow-sm">
                    <img
                    src={partner?.logo}
                    alt={`Logo ${partner?.name}`}
                    className="max-h-20 max-w-full object-contain opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `<div class="text-2xl font-bold" style="color: #96121D;">${partner?.name}</div>`;
                    }} />

                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {partner?.name}
                  </h3>

                  <p className="text-lg font-semibold mb-2" style={{ color: '#9B8E57' }}>
                    {partner?.fullName}
                  </p>

                  <p
                  className="text-sm font-semibold mb-4"
                  style={{ color: '#96121D' }}>

                    {partner?.role}
                  </p>

                  <p className="text-gray-600 leading-relaxed mb-6">
                    {partner?.description}
                  </p>

                  {/* Benefits */}
                  <div className="space-y-2">
                    <p className="text-sm font-semibold text-gray-900 mb-3">Avantages :</p>
                    {partner?.benefits?.map((benefit, benefitIndex) =>
                  <div key={benefitIndex} className="flex items-start space-x-2">
                        <Icon name="CheckCircle" size={16} style={{ color: '#96121D', marginTop: '2px' }} />
                        <span className="text-sm text-gray-600">{benefit}</span>
                      </div>
                  )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Section 3: Nos Clients */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <div className="inline-flex items-center space-x-2 bg-white rounded-full px-4 py-2 mb-4">
                <Icon name="Users" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Nos Clients
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Nos Clients
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Des institutions portuaires majeures qui nous font confiance
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {clients?.map((client, index) =>
              <div
                key={index}
                className="bg-white rounded-xl p-8 transition-all duration-300 hover:shadow-xl"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>

                  <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{ backgroundColor: 'rgba(150, 18, 29, 0.1)' }}>

                    <Icon
                    name={client?.icon}
                    size={32}
                    style={{ color: '#96121D' }} />

                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
                    {client?.name}
                  </h3>

                  <p
                  className="text-sm font-semibold mb-4 text-center"
                  style={{ color: '#9B8E57' }}>

                    {client?.country}
                  </p>

                  <p className="text-gray-600 text-sm leading-relaxed mb-4 text-center">
                    {client?.description}
                  </p>

                  <div className="pt-4 border-t border-gray-200">
                    <p className="text-xs font-semibold text-gray-500 mb-2 text-center">Services fournis :</p>
                    <p className="text-sm text-gray-700 text-center">
                      {client?.services}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Section 4: Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Les Avantages de Notre Réseau
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Bénéficiez de l'excellence de nos partenaires et de notre expérience client
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits?.map((benefit, index) =>
              <div
                key={index}
                className="bg-gray-50 rounded-xl p-6 text-center transition-all duration-300 hover:shadow-lg"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>

                  <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                  style={{
                    backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                  }}>

                    <Icon
                    name={benefit?.icon}
                    size={32}
                    style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} />

                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit?.title}
                  </h3>

                  <p className="text-gray-600 text-sm leading-relaxed">
                    {benefit?.description}
                  </p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Section 5: CTA */}
        <section
          className="relative py-20 text-white overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #96121D 0%, #7d0f18 100%)'
          }}>

          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `
                linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px),
                linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
              `,
              backgroundSize: '40px 40px'
            }} />
          </div>

          <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <Icon name="Users" size={20} style={{ color: '#9B8E57' }} />
              <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                Rejoignez Notre Réseau
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Devenez Partenaire CRF PERFECTION
            </h2>
            
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Rejoignez notre écosystème d'excellence et collaborez avec nous pour transformer 
              les organisations et développer les talents de demain.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold bg-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                style={{ color: '#96121D' }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#9B8E57';
                  e.target.style.color = '#ffffff';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#ffffff';
                  e.target.style.color = '#96121D';
                  e.target.style.transform = 'translateY(0)';
                }}>

                Contactez-Nous
                <Icon name="Mail" size={20} className="ml-2" />
              </Link>

              <Link
                to="/services"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 border-white transition-all duration-300"
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }}>

                Découvrir Nos Services
                <Icon name="ArrowRight" size={20} className="ml-2" />
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>);

};

export default PartnersPage;